/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lucio API
 * Lucio AI Outlook Add-in Backend API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeleteAttachmentsBulkDelete200,
  DeleteAttachmentsBulkDeleteBody,
  DeleteAttachmentsById200,
  ErrorResponse,
  GetAttachmentsByIdAccessUrl200,
  GetAttachmentsByIdAccessUrlParams,
  GetAttachmentsList200Item,
  GetAttachmentsListParams,
  PostAttachmentsBulkUpload200Item,
  PostAttachmentsBulkUploadBody,
  PostAttachmentsUpload200,
  PostAttachmentsUploadBody,
  ValidationErrorResponse
} from '../lucioAPI.schemas';

import { customInstance } from '../../mutator';




/**
 * Upload a file attachment. Optionally specify a purpose (SESSION or NARRATIVE).
 * @summary Upload a single file
 */
export const postAttachmentsUpload = (
    postAttachmentsUploadBody: PostAttachmentsUploadBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, postAttachmentsUploadBody.file)
if(postAttachmentsUploadBody.purpose !== undefined) {
 formData.append(`purpose`, postAttachmentsUploadBody.purpose)
 }

      return customInstance<PostAttachmentsUpload200>(
      {url: `/attachments/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getPostAttachmentsUploadMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAttachmentsUpload>>, TError,{data: PostAttachmentsUploadBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAttachmentsUpload>>, TError,{data: PostAttachmentsUploadBody}, TContext> => {

const mutationKey = ['postAttachmentsUpload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAttachmentsUpload>>, {data: PostAttachmentsUploadBody}> = (props) => {
          const {data} = props ?? {};

          return  postAttachmentsUpload(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAttachmentsUploadMutationResult = NonNullable<Awaited<ReturnType<typeof postAttachmentsUpload>>>
    export type PostAttachmentsUploadMutationBody = PostAttachmentsUploadBody
    export type PostAttachmentsUploadMutationError = ErrorResponse

    /**
 * @summary Upload a single file
 */
export const usePostAttachmentsUpload = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAttachmentsUpload>>, TError,{data: PostAttachmentsUploadBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAttachmentsUpload>>,
        TError,
        {data: PostAttachmentsUploadBody},
        TContext
      > => {

      const mutationOptions = getPostAttachmentsUploadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Upload multiple file attachments in a single request.
 * @summary Upload multiple files
 */
export const postAttachmentsBulkUpload = (
    postAttachmentsBulkUploadBody: PostAttachmentsBulkUploadBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
postAttachmentsBulkUploadBody.files.forEach(value => formData.append(`files`, value));
if(postAttachmentsBulkUploadBody.purpose !== undefined) {
 formData.append(`purpose`, postAttachmentsBulkUploadBody.purpose)
 }

      return customInstance<PostAttachmentsBulkUpload200Item[]>(
      {url: `/attachments/bulk-upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getPostAttachmentsBulkUploadMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAttachmentsBulkUpload>>, TError,{data: PostAttachmentsBulkUploadBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAttachmentsBulkUpload>>, TError,{data: PostAttachmentsBulkUploadBody}, TContext> => {

const mutationKey = ['postAttachmentsBulkUpload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAttachmentsBulkUpload>>, {data: PostAttachmentsBulkUploadBody}> = (props) => {
          const {data} = props ?? {};

          return  postAttachmentsBulkUpload(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAttachmentsBulkUploadMutationResult = NonNullable<Awaited<ReturnType<typeof postAttachmentsBulkUpload>>>
    export type PostAttachmentsBulkUploadMutationBody = PostAttachmentsBulkUploadBody
    export type PostAttachmentsBulkUploadMutationError = ErrorResponse

    /**
 * @summary Upload multiple files
 */
export const usePostAttachmentsBulkUpload = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAttachmentsBulkUpload>>, TError,{data: PostAttachmentsBulkUploadBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAttachmentsBulkUpload>>,
        TError,
        {data: PostAttachmentsBulkUploadBody},
        TContext
      > => {

      const mutationOptions = getPostAttachmentsBulkUploadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Retrieve all attachments for the current user filtered by purpose.
 * @summary List attachments by purpose
 */
export const getAttachmentsList = (
    params: GetAttachmentsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAttachmentsList200Item[]>(
      {url: `/attachments/list`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAttachmentsListQueryKey = (params?: GetAttachmentsListParams,) => {
    return [
    `/attachments/list`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAttachmentsListQueryOptions = <TData = Awaited<ReturnType<typeof getAttachmentsList>>, TError = ValidationErrorResponse | ErrorResponse>(params: GetAttachmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttachmentsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttachmentsList>>> = ({ signal }) => getAttachmentsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttachmentsListQueryResult = NonNullable<Awaited<ReturnType<typeof getAttachmentsList>>>
export type GetAttachmentsListQueryError = ValidationErrorResponse | ErrorResponse


export function useGetAttachmentsList<TData = Awaited<ReturnType<typeof getAttachmentsList>>, TError = ValidationErrorResponse | ErrorResponse>(
 params: GetAttachmentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentsList>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentsList<TData = Awaited<ReturnType<typeof getAttachmentsList>>, TError = ValidationErrorResponse | ErrorResponse>(
 params: GetAttachmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentsList>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentsList<TData = Awaited<ReturnType<typeof getAttachmentsList>>, TError = ValidationErrorResponse | ErrorResponse>(
 params: GetAttachmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List attachments by purpose
 */

export function useGetAttachmentsList<TData = Awaited<ReturnType<typeof getAttachmentsList>>, TError = ValidationErrorResponse | ErrorResponse>(
 params: GetAttachmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttachmentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete multiple attachments by their IDs.
 * @summary Bulk delete attachments
 */
export const deleteAttachmentsBulkDelete = (
    deleteAttachmentsBulkDeleteBody: DeleteAttachmentsBulkDeleteBody,
 ) => {
      
      
      return customInstance<DeleteAttachmentsBulkDelete200>(
      {url: `/attachments/bulk-delete`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteAttachmentsBulkDeleteBody
    },
      );
    }
  


export const getDeleteAttachmentsBulkDeleteMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachmentsBulkDelete>>, TError,{data: DeleteAttachmentsBulkDeleteBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAttachmentsBulkDelete>>, TError,{data: DeleteAttachmentsBulkDeleteBody}, TContext> => {

const mutationKey = ['deleteAttachmentsBulkDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAttachmentsBulkDelete>>, {data: DeleteAttachmentsBulkDeleteBody}> = (props) => {
          const {data} = props ?? {};

          return  deleteAttachmentsBulkDelete(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAttachmentsBulkDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAttachmentsBulkDelete>>>
    export type DeleteAttachmentsBulkDeleteMutationBody = DeleteAttachmentsBulkDeleteBody
    export type DeleteAttachmentsBulkDeleteMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Bulk delete attachments
 */
export const useDeleteAttachmentsBulkDelete = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachmentsBulkDelete>>, TError,{data: DeleteAttachmentsBulkDeleteBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAttachmentsBulkDelete>>,
        TError,
        {data: DeleteAttachmentsBulkDeleteBody},
        TContext
      > => {

      const mutationOptions = getDeleteAttachmentsBulkDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Issue a short-lived (60-minute) Azure SAS URL for the attachment. The URL has Content-Disposition (inline or attachment) baked in, so the browser handles it accordingly without further headers from us.
 * @summary Get a short-lived access URL for an attachment
 */
export const getAttachmentsByIdAccessUrl = (
    id: string,
    params: GetAttachmentsByIdAccessUrlParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAttachmentsByIdAccessUrl200>(
      {url: `/attachments/${id}/access-url`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAttachmentsByIdAccessUrlQueryKey = (id?: string,
    params?: GetAttachmentsByIdAccessUrlParams,) => {
    return [
    `/attachments/${id}/access-url`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAttachmentsByIdAccessUrlQueryOptions = <TData = Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>, TError = ErrorResponse>(id: string,
    params: GetAttachmentsByIdAccessUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttachmentsByIdAccessUrlQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>> = ({ signal }) => getAttachmentsByIdAccessUrl(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttachmentsByIdAccessUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>>
export type GetAttachmentsByIdAccessUrlQueryError = ErrorResponse


export function useGetAttachmentsByIdAccessUrl<TData = Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>, TError = ErrorResponse>(
 id: string,
    params: GetAttachmentsByIdAccessUrlParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentsByIdAccessUrl<TData = Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>, TError = ErrorResponse>(
 id: string,
    params: GetAttachmentsByIdAccessUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentsByIdAccessUrl<TData = Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>, TError = ErrorResponse>(
 id: string,
    params: GetAttachmentsByIdAccessUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a short-lived access URL for an attachment
 */

export function useGetAttachmentsByIdAccessUrl<TData = Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>, TError = ErrorResponse>(
 id: string,
    params: GetAttachmentsByIdAccessUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentsByIdAccessUrl>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttachmentsByIdAccessUrlQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete a single attachment by its ID.
 * @summary Delete an attachment
 */
export const deleteAttachmentsById = (
    id: string,
 ) => {
      
      
      return customInstance<DeleteAttachmentsById200>(
      {url: `/attachments/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAttachmentsByIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachmentsById>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAttachmentsById>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAttachmentsById'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAttachmentsById>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAttachmentsById(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAttachmentsByIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAttachmentsById>>>
    
    export type DeleteAttachmentsByIdMutationError = ErrorResponse

    /**
 * @summary Delete an attachment
 */
export const useDeleteAttachmentsById = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachmentsById>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAttachmentsById>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAttachmentsByIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    